import { jsx as t, Fragment as n } from "react/jsx-runtime";
import { Checkbox as s } from "antd";
import { useStateTogether as h } from "react-together";
function u({
  rtKey: o,
  ...e
}) {
  const [r, a] = h(o, !1);
  return /* @__PURE__ */ t(n, { children: /* @__PURE__ */ t(
    s,
    {
      ...e,
      onChange: (c) => a(c.target.checked || !1),
      checked: r,
      className: `outline outline-1 outline-gray-400 rounded ${e.className}`
    }
  ) });
}
export {
  u as default
};
